// app/javascript/controllers/offer_line_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "normalFields", "percentageFields", "priceLabel",
    "quantity", "unitPrice", "percentageRate", "billingModel",
    "net", "netDisplay", "gross", "vatRate"
  ]

  static values = {
    priceLabelNormal: String,
    priceLabelPercentage: String
  }

  connect() {
    const isPercentage = this.hasBillingModelTarget
      ? this.billingModelTarget.value === "percentage"
      : parseFloat(this.percentageRateTarget.value) > 0

    this._toggleLayout(isPercentage)
    this.calculate()
  }

  disconnect() {
    this.element.dispatchEvent(new CustomEvent("offer:recalculate", { bubbles: true }))
  }

  updateMode(event) {
    const isPercentage = event.detail.billingModel === "percentage" || event.detail.isPercentage === true
    this._toggleLayout(isPercentage)
  }

  _toggleLayout(isPercentage) {
    if (isPercentage) {
      this.normalFieldsTarget.classList.add("d-none")
      this.percentageFieldsTarget.classList.remove("d-none")
      this.mode = "percentage"
    } else {
      this.normalFieldsTarget.classList.remove("d-none")
      this.percentageFieldsTarget.classList.add("d-none")
      this.mode = "normal"
    }

    if (this.hasPriceLabelTarget) {
      this.priceLabelTarget.textContent = isPercentage
        ? this.priceLabelPercentageValue
        : this.priceLabelNormalValue
    }

    this.calculate()
  }

  calculate() {
    let net = 0
    const qty = parseFloat(this.quantityTarget.value) || 0
    const price = parseFloat(this.unitPriceTarget.value) || 0
    const vatRate = parseFloat(this.vatRateTarget.value) || 0

    if (this.mode === "percentage") {
      const rate = parseFloat(this.percentageRateTarget.value) || 0
      net = price * (rate / 100.0) * (qty || 1)
    } else {
      net = qty * price
    }

    const gross = net * (1 + (vatRate / 100.0))

    if (this.hasNetTarget) this.netTarget.value = net.toFixed(4)
    if (this.hasGrossTarget) this.grossTarget.value = gross.toFixed(4)

    if (this.hasNetDisplayTarget) {
      this.netDisplayTarget.value = net.toLocaleString(document.documentElement.lang || "de-DE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }) + " €"
    }

    this.element.dispatchEvent(new CustomEvent("offer:recalculate", { bubbles: true }))
  }
}